module.exports = __webpack_public_path__ + "img/people-23.fdc90453.png";